export function hasCreditNoteCae(sale) {
  return !!(sale && sale.creditNoteData && sale.creditNoteData.cae);
}

/** Factura AFIP neta: hay comprobante y no fue anulado con nota de crédito. */
export function isNetInvoiced(sale) {
  if (!sale || !sale.invoiceData) return false;
  if (sale.invoiceVoided === true) return false;
  if (hasCreditNoteCae(sale)) return false;
  return true;
}

export function getInvoiceStatusMeta(sale) {
  if (hasCreditNoteCae(sale) || sale?.invoiceVoided === true) {
    return { label: 'Factura anulada (NC)', tone: 'voided' };
  }
  if (sale && sale.invoiceData) {
    return { label: 'Factura emitida', tone: 'issued' };
  }
  return { label: 'Sin factura', tone: 'none' };
}
